import { State, Ng1StateDeclaration } from "angular-ui-router";

export class NavService {

    pages: Array<NavItem>;

    constructor() {
        this.pages = new Array<NavItem>();
    }

    addNavItem(page: NavItem): void {
        this.pages.push(page);
    }
}


export interface NavItem {
    state: string;
    url: string;
    label: string;
    icon: string;
}


/** WEBPACK FOOTER **
 ** ./src/app/common/nav/nav.service.ts
 **/